import { configureStore } from "@reduxjs/toolkit";

// IMPORTANT: imports for all other slices go here
// Import DealsTableSlice as default import from the specified file
import DealsTableSlice from "./DealsTableSlice_Store";
import ResearchDocsSlice from "./ResearchDocsSlice_Store";
// Import NavigationSlice as default import from the specified file
import NavigationSlice from "./NavigationSlice_Store";
// Import ChatSlice as default import from the specified file
import ChatSlice from "./ChatSlice_Store";
import UserAuthAndAdminSlice from "./UserAuthAndAdminSlice_Store";
import ResultsSlice from "./ResultsSlice_Store";
import ProjectSlice from "./ProjectSlice_Store";
import DocumentPreviewSlice from "./DocumentPreviewSlice_Store";
import LayoutSlice from "./LayoutSlice_Store";
import DraftSelectionSlice from "./DraftSelectionSlice_Store";
import StreamingSlice from "./streaming/streamingSlice";
import streamingListenerMiddleware from "./streaming/streamingListener";

// Configure the Redux store with all integrated slices
const store = configureStore({
  reducer: {
    // Integrate DealsTableSlice into the root reducer under the key 'dealsTableSlice'
    // as specified in the DealsTableSlice's contract
    dealsTableSlice: DealsTableSlice,
    researchDocsSlice: ResearchDocsSlice,
    // Integrate NavigationSlice into the root reducer under the key 'navigationSlice'
    // as specified in the NavigationSlice's StoreKey property contract
    navigationSlice: NavigationSlice,
    // Integrate ChatSlice into the root reducer under the key 'chatSlice'
    // as specified in the ChatSlice's contract
    chatSlice: ChatSlice,
    resultsSlice: ResultsSlice,
    userAuthAndAdminSlice: UserAuthAndAdminSlice,
    projectSlice: ProjectSlice,
    documentPreview: DocumentPreviewSlice,
    layoutSlice: LayoutSlice,
    draftSelectionSlice: DraftSelectionSlice,
    streaming: StreamingSlice,
  },
  // Register listener middleware for streaming animation
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(streamingListenerMiddleware),
});

// Make store available globally for chat listener to access project state
if (typeof window !== 'undefined') {
  window.store = store;
}

// Export store types for hooks
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
